@if (previousPointTitle()) {
  <span class="point-titles__previous ci-paragraph-p1-semibold">
    <span class="previous__from">{{ 'De' | translate }} </span>
    <span class="previous__point ci-paragraph-p1-regular">{{ previousPointTitle() }}</span>
  </span>
}